import React from 'react';
import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { getMixedContentInOrder } from '../../../contentDefinitionInterfaces/ContentDefinitionsLists';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { SpaceInfo, SpaceItemForNonEntitySpace, SpaceType } from '../../state/SpaceInfo';
import { ExplorerEmptyStateProps } from '../Components/ExplorerEmpyState';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { ExplorerToolbarTestIds } from '../Explorer/ExplorerToolbar';
import { FilterByTypeDropdown } from '../Explorer/FilterByTypeDropdown';
import { ProjectDefinition } from '../../../contentDefinitions/ProjectDefinition';


export interface SharedWithMeSpaceOwnProps extends ReactDirectiveProps {
  // TODO - Props for shared with me
  // WHATEVER you add here, it needs to be passed from SharedWithMeSpaceProvider
}

export interface SharedWithMeSpaceAngularProps {
  readonly browserTitleService: BrowserTitleService;
}

export interface SharedWithMeSpaceStateProps {
  readonly contentTypeFilterValues: ReadonlyArray<ExplorableItemType>;
  readonly defaultContentTypeFilterValues: ReadonlyArray<ExplorableItemType>;
}

export interface SharedWithMeSpaceDispatchProps {
  readonly clearContentCounts: (spaceType: SpaceType) => void;
  readonly filterSelected: (selectedItems: ArrayLike<ExplorableItemType>) => void;
  readonly requestSpaceContents: () => void;
}

export type SharedWithMeSpaceProps = SharedWithMeSpaceStateProps
  & SharedWithMeSpaceDispatchProps
  & SharedWithMeSpaceOwnProps
  & SharedWithMeSpaceAngularProps;

const SharedWithMeSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'sharedWithMe',
  subspaceName: undefined
};

const testIdPrefix = 'shared-with-me';
const HEADER_TEST_ID = `${testIdPrefix}-header`;
const EMPTY_STATE_TEST_ID = `${testIdPrefix}-empty-state`;

export class SharedWithMeSpace extends React.PureComponent<SharedWithMeSpaceProps> {

  public componentDidMount() {
    this.props.browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.sharedWithMeTitle() });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return (
      <div className={SpaceContainerStyles.SpaceContainer}>
        <div className={SpaceContainerStyles.MastheadArea}>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div data-tb-test-id={HEADER_TEST_ID} className={ExplorerStyles.SpaceHeaderText}>{Messages.sharedWithMeTitle()}</div>
          </div>
        </div>
        <div className={SpaceContainerStyles.SubplaceArea}>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={ProjectDefinition.supportedDisplayModes}
            emptyStateProps={this.emptyStateProps()}
            toolbarProps={{
              supportFilterPanel: false,
              // toolbarContentFilterControl: this.contentFilterControl(),  // Uncomment to show content type filter
              toolbarVisibility: 'enabled'
            }}
          />
        </div>
      </div>
    );
  }

  private contentFilterControl(): JSX.Element {
    return (
      <React.Fragment>
        <span id={ExplorerToolbarTestIds.FilterByTypeDropdownButtonLabel} className={ExplorerStyles.ToolbarDropdownLabel}>
           {Messages.filterByTypeDropdown_label()}
        </span>
        {FeatureFlags.contentTypeMenuUpdate &&
          <FilterByTypeDropdown
            filterSelected={this.props.filterSelected}
            contentFilter={this.props.contentTypeFilterValues}
            defaultContentTypeFilterValues={this.props.defaultContentTypeFilterValues}
            clearContentCounts={this.props.clearContentCounts}
            spaceType={SharedWithMeSpaceInfo.spaceType}
            contentItemDefinitions={getMixedContentInOrder()}
          />}
      </React.Fragment>
    );
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      iconUrl: imgPath('spaces_shared_with_me_empty_state.svg'),
      primaryMessage: Messages.sharedWithMeEmptyStatePrimary(),
      secondaryMessage: Messages.sharedWithMeEmptyStateSecondary(),
      dataTestId: EMPTY_STATE_TEST_ID,
    };
  }
}
